module.exports = __webpack_public_path__ + "img/import.8d3e2b49.svg";